const ZDANIA4 = [
  {
    name: "Niemiecki: Obst",
    lang: 'de',
    zdania: [
      {
        pl: "jabłko",
        de: "der Apfel",
      },
      {
        pl: "gruszka",
        de: "die Birne",
      },
      {
        pl: "wiśnia",
        de: "die Sauerkirsche",
      },
      {
        pl: "śliwka",
        de: "die Pflaume",
      },
      {
        pl: "truskawka",
        de: "die Erdbeere",
      },
      {
        pl: "zurawina",
        de: "die Moosbeere",
      },
      {
        pl: "brzoskwinia",
        de: "der Pfirsch",
      },
      {
        pl: "arbuz",
        de: "die Wassermelone",
      },
      {
        pl: "malina",
        de: "die Himbeere",
      },
      {
        pl: "winogrono",
        de: "die Weintraube",
      },
      {
        pl: "czereśnia",
        de: "die Kirsche",
      },
      {
        pl: "Te jabłka są dla nas",
        de: "These apples are for us",
      },
      {
        pl: "porzeczka",
        de: "die Johannisbeere",
      },
      {
        pl: "borówka amerykańska",
        de: "die Blaubeere",
      },
      {
        pl: "agrest",
        de: "die Stachelbeere",
      },
      {
        pl: "morwa",
        de: "die Maulbeere",
      },
      {
        pl: "poziomka",
        de: "die Erdbeere",
      },
      {
        pl: "orzech włoski",
        de: "die Walnuss",
      },
      {
        pl: "jeżyna",
        de: "die Brombeere",
      },
      {
        pl: "morela",
        de: "der Aprikose",
      },
      {
        pl: "orzech laskowy",
        de: "die Haselnuss",
      },
      {
        pl: "bez czarny",
        de: "der schwarze Halunder",
      },
    ],
  },
];

const ZDANIA5 = [
  {
    name: "Niemiecki: Meine Schulsachen",
    lang: 'de',
    zdania: [
      {
        pl: "tornister",
        de: "die Shultasche",
      },
      {
        pl: "nozyczki",
        de: "die Schere",
      },
      {
        pl: "teczka",
        de: "die Mappe",
      },
      {
        pl: "mapa",
        de: "die Landkarte",
      },
      {
        pl: "naboj do piora",
        de: "die Tintenpatrone",
      },
      {
        pl: "ksiązka",
        de: "das Buch",
      },
      {
        pl: "zeszyt",
        de: "das Heflt",
      },
      {
        pl: "linijka",
        de: "das Lineal",
      },
      {
        pl: "piórnik",
        de: "das Mäppchen",
      },
      {
        pl: "olówek",
        de: "der Bleistift",
      },
      {
        pl: "dlugopis",
        de: "der Kuli",
      },
      {
        pl: "strugawka",
        de: "der Spitzer",
      },
      {
        pl: "gumka",
        de: "der Radiergummi",
      },
      {
        pl: "zakreślacz",
        de: "der Textmarker",
      },
      {
        pl: "mazak",
        de: "der Filzstift",
      },
      {
        pl: "kredka",
        de: "der Buntstift",
      },
      {
        pl: "pióro na atrament",
        de: "der Füller",
      },
      {
        pl: "korektor",
        de: "der Korrekturstift",
      },
      {
        pl: "klej",
        de: "der Klebstoff",
      },
      {
        pl: "kalkulator",
        de: "der Taschenrechner",
      },
      {
        pl: "ekierka",
        de: "der Zeichenwinkel",
      },
      {
        pl: "cyrkiel",
        de: "der Zirkel",
      },
      {
        pl: "ksiązki (l.m.)",
        de: "die Bücher",
      },
      {
        pl: "zeszyty(l.m.)",
        de: "die Hefte",
      },
      {
        pl: "ołówki (l.m.)",
        de: "die Bleistifte",
      },
      {
        pl: "mazaki (l.m.)",
        de: "die Filzstifte",
      },
      {
        pl: "linijki (l.m.)",
        de: "die Lineale",
      },
      {
        pl: "piórniki (l.m.)",
        de: "die Mäppchen",
      },
      {
        pl: "markerz (l.m.)",
        de: "die Textmarker",
      },
      {
        pl: "strugawki (l.m.)",
        de: "die Spitzer",
      },
      {
        pl: "mapy (l.m.)",
        de: "die Landkarten",
      },
      {
        pl: "teczki (l.m.)",
        de: "die Mappen",
      },
      {
        pl: "nozyczki (l.m.)",
        de: "die Scheren",
      },
      {
        pl: "tornistry (l.m.)",
        de: "die Shultaschen",
      },
      {
        pl: "pióra (l.m.)",
        de: "die Füller",
      },
      {
        pl: "kleje (l.m.)",
        de: "die Klebstoffe",
      },
      {
        pl: "kalkulatory (l.m.)",
        de: "die Taschenrechner",
      },
      {
        pl: "ekierki (l.m.)",
        de: "die Zeichenwinkel",
      },
      {
        pl: "długopisy (l.m.)",
        de: "die Kulis",
      },
      {
        pl: "kredtki (l.m.)",
        de: "die Buntstifte",
      },
      {
        pl: "gumki (l.m.)",
        de: "die Radiergummis",
      },
    ],
  },
];

const ZDANIA6 = [
  {
    name: "Niemiecki: Przedmioty szkolne",
    lang: 'de',
    zdania: [
      {
        pl: "niemieck",
        de: "Deutsch",
      },
      {
        pl: "matematyka",
        de: "Mathematik",
      },
      {
        pl: "wf",
        de: "Sport",
      },
      {
        pl: "geografia",
        de: "Erdkunde",
      },
      {
        pl: "plastyka",
        de: "Kunst",
      },
      {
        pl: "biologia",
        de: "Biologie",
      },
      {
        pl: "zajęcia praktyczno-techniczne",
        de: "Werken",
      },
      {
        pl: "francuski",
        de: "Französisch",
      },
      {
        pl: "religia",
        de: "Religion",
      },
      {
        pl: "etyka",
        de: "Ethik",
      },
      {
        pl: "język angielski",
        de: "Englisch",
      },
      {
        pl: "historia",
        de: "Geschichte",
      },
      {
        pl: "godzina wychowawcza",
        de: "Klassenlehrerstunde",
      },
      {
        pl: "muzyka",
        de: "Musik",
      },
      {
        pl: "informatyka",
        de: "Informatik",
      },
      {
        pl: "Jaki jest Twój ulubiony przedmiot?",
        de: "Was ist dein Lieblingsfach?",
      },
      {
        pl: "Moim ulubionym przedmiotem jest muzyka",
        de: "Mein Lieblingsfach ist Musik",
      },
      {
        pl: "Jaki przedmiot ma Tina w poniedzialek",
        de: "Was hat Tina am Montag?",
      },
      {
        pl: "W poniedzialek ona ma niemiecki i matematyke",
        de: "Am Montag hat Sie Deutsch und Mathematik",
      },
      {
        pl: "Kiedy Tina ma niemiecki?",
        de: "Wann hat Tina Deutsch?",
      },
      {
        pl: "W poniedzialek",
        de: "Am Montag",
      },
      {
        pl: "Ile masz długopisów? ",
        de: "Wie viele Kugelschreiber hast du?",
      },
      {
        pl: "Mam trzy długopisy",
        de: "Ich habe drei Kugelschreiber",
      },
      {
        pl: "Ile masz ksiazek?",
        de: "Wie viele Bücher hast du?",
      },
      {
        pl: "Czy potrzebujesz tej gumki do mazania?",
        de: "Brauchst du den Radiergummi?",
      },
      {
        pl: "Tak potrzebuje tej gumki do mazania",
        de: "Ja ich brauche den Radiergummi",
      },
      {
        pl: "Nie nie potrzebuję gumki",
        de: "Nein den Radiergummi brauche ich nicht",
      },
      {
        pl: "Czy potrzebujesz linijki?",
        de: "Brauchst du das Lineal?",
      },
      {
        pl: "Thomas szuka zakreslacza",
        de: "Thomas sucht den Textmarker",
      },
      {
        pl: "Jaki jest Twój ulubiony przedmiot?",
        de: "Was ist dein Lieblingsfach?",
      },
      {
        pl: "Moim ulubionym przedmiotem jest muzyka",
        de: "Mein Lieblingsfach ist Musik",
      },
      {
        pl: "We wtorek",
        de: "Am Dienstag",
      },
      {
        pl: "Co ma Tina w poniedzialek?",
        de: "Was hat Tina am Montag?",
      },
      {
        pl: "W poniedziałek ma niemiecki, matematykę, dwie godziny wF",
        de: "Am Montag hat sie Deutsch, Mathematik, zwei Stunden Sport",
      },
      {
        pl: "Kiedy Tina ma niemiecki?",
        de: "Wann hat Tina Deutsch?",
      },
      {
        pl: "W poniedziałek wtorek środę i piątek",
        de: "Am Montag am Dienstag am Mittwoch und am Freitag",
      },
      {
        pl: "Tina, jak ci się podoba matematyka?",
        de: "Tina wie findest du Mathe?",
      },
      {
        pl: "Matematyka jest dla mnie nudna",
        de: "Mathe finde ich langweilig",
      },
      {
        pl: "Tina, jak ci się podoba wf?",
        de: "Tina wie findest du Sport?",
      },
      {
        pl: "WF jest dla mnie latwy",
        de: "Sport finde ich leicht",
      },
      {
        pl: "WF jest dla mnie latwy",
        de: "Sport finde ich leicht",
      },
      {
        pl: "swietny",
        de: "toll",
      },
      {
        pl: "glupi",
        de: "doof",
      },
      {
        pl: "nieinteresujacy",
        de: "uninteressant",
      },
      {
        pl: "trudny ciezki",
        de: "schwer",
      },
      {
        pl: "skomplikowany",
        de: "kompliziert",
      },
      {
        pl: "Jakie przedmioty lubi Tina?",
        de: "Welche Fächer mag Tina?",
      },
      {
        pl: "Jakie przedmioty nie lubi Tina?",
        de: "Welche Fächer mag Tina nicht?",
      },
      {
        pl: "Gdzie teraz jesteś?",
        de: "Wo bist du jetzt?",
      },
      {
        pl: "Gdzie teraz jesteś?",
        de: "Wo bist du jetzt?",
      },
      {
        pl: "Niedziela to mój ulubiony dzień",
        de: "Sonntag ist mein Lieblingstag",
      },
      {
        pl: "Uważam, że moja szkoła jest swietna",
        de: "Meine Schule finde ich toll",
      },
      {
        pl: "Czy lubisz język niemiecki?",
        de: "Magst du Deutsch?",
      },
      {
        pl: "Kiedy masz WF?",
        de: "Wann hast du Sport?",
      },
      {
        pl: "Co masz w swoim plecaku ?",
        de: "Was hast du in deinem Mäpchen?",
      },
      {
        pl: "Ona potrzebuje cyrlka",
        de: "Sie braucht einen Zirkel",
      },
      {
        pl: "Czy Pani potrzebuje temperowki",
        de: "Brauchen Sie den Spitzer",
      },
      {
        pl: "To są książki",
        de: "Das sind Bücher",
      },
      {
        pl: "obliczyc",
        de: "rechnen",
      },
      {
        pl: "czytac",
        de: "lesen",
      },
      {
        pl: "mlody",
        de: "jung",
      },
      {
        pl: "technika",
        de: "Werken",
      },
      {
        pl: "jeszcze raz",
        de: "noch einmal",
      },
      {
        pl: "On bierze klej",
        de: "Er nimmt einen Klebstoff",
      },
    ],
  },
];

const ZDANIA7 = [
  {
    name: "Ang: na sprawdzian",
    lang: 'en',
    zdania: [
      {
        pl: "czajnik",
        de: "a katlle",
      },
      {
        pl: "dywanik",
        de: "a rug",
      },
      {
        pl: "półka na ksiązki",
        de: "a bookshelf",
      },
      {
        pl: "piekarnik",
        de: "an oven",
      },
      {
        pl: "mikrofalówka",
        de: "a microwave",
      },
      {
        pl: "odkurzacz",
        de: "a vacuum cleaner",
      },
      {
        pl: "zmywarka",
        de: "a vacuum cleaner",
      },
      {
        pl: "lodówka",
        de: "a frigde",
      },
      {
        pl: "zamrazalka",
        de: "a freezer",
      },
      {
        pl: "kieliszek, szklanka",
        de: "a glass",
      },
      {
        pl: "dzbanek",
        de: "a jug",
      },
      {
        pl: "łyzka",
        de: "a spoon",
      },
      {
        pl: "widelec",
        de: "a fork",
      },
      {
        pl: "miska",
        de: "a bowl",
      },
      {
        pl: "talerz",
        de: "a plate",
      },
      {
        pl: "filizanka, kubek",
        de: "a cup",
      },
      {
        pl: "patelnia",
        de: "a frying pan",
      },
      {
        pl: "zlew",
        de: "a sink",
      },
      {
        pl: "dzbanek do herbaty",
        de: "a tepot",
      },
      {
        pl: "salon",
        de: "a living room",
      },
      {
        pl: "zwykly na lit. c",
        de: "common",
      },
      {
        pl: "zwykly na lit. o.",
        de: "ordinary",
      },
      {
        pl: "kształt",
        de: "shape",
      },
      {
        pl: "jadalnia",
        de: "a dining room",
      },
      {
        pl: "toaleta",
        de: "a toilet",
      },
      {
        pl: "strych",
        de: "an attic",
      },
      {
        pl: "piwnica",
        de: "a basement",
      },
      {
        pl: "garaz, warsztat samochodowy",
        de: "a garage",
      },
      {
        pl: "lazienka",
        de: "a bathroom",
      },
      {
        pl: "prysznic",
        de: "a shower",
      },
      {
        pl: "wanna",
        de: "a bath",
      },
      {
        pl: "recznik",
        de: "a towel",
      },
      {
        pl: "glabka",
        de: "a sponge",
      },
      {
        pl: "grzebien",
        de: "a comb",
      },
      {
        pl: "szafa",
        de: "a wardrobe",
      },
      {
        pl: "poduszka",
        de: "a pillow",
      },
      {
        pl: "lustro",
        de: "a mirror",
      },
      {
        pl: "pasta do zebow",
        de: "a toothpaste",
      },
      {
        pl: "szczoteczka do zebow",
        de: "a toothbrush",
      },
      {
        pl: "przescieradlo",
        de: "a sheet",
      },
      {
        pl: "kołdra",
        de: "a duvet",
      },
      {
        pl: "suszarka do wlosów",
        de: "a hair dryer ",
      },
    ],
  },
];

const ZDANIA8 = [
  {
    name: "Niemiecki: Mod 3 Kap 3",
    lang: 'de',
    zdania: [
      {
        pl: "Czy jesteś fanem telewizji?",
        de: "Bist du ein Fernsehfan?",
      },
      {
        pl: "Czy lubisz oglądać telewizję?",
        de: "Siehst du gern fern?",
      },
      {
        pl: "Ile godzin dziennie oglądasz telewizję?",
        de: "Wie viele Stunden pro Tag siehst du fern?",
      },
      {
        pl: "Od której do której oglądasz telewizję?",
        de: "Von wann bis wann siehst du fern?",
      },
      {
        pl: "teleturniej Quiz",
        de: "die Quizshow",
      },
      {
        pl: "Wiadomości",
        de: "die Nachrichten",
      },
      {
        pl: "film",
        de: "der Film",
      },
      {
        pl: "serial animowany",
        de: "die Zeichentrickserie",
      },
      {
        pl: "film dokumentalny",
        de: "der Dokumentarfilm",
      },
      {
        pl: "program kulturalny",
        de: "das Kulturprogramm",
      },
      {
        pl: "thirel, dreszczowiec, film kryminalny",
        de: "der Krimi",
      },
      {
        pl: "program sportowy",
        de: "die Sportsendung",
      },
      {
        pl: "Lubię oglądać teleturnieje",
        de: "Ich sehe gern Quizshows",
      },
      {
        pl: "Co lubisz oglądać?",
        de: "Was siehst du gern?",
      },
      {
        pl: "Oglądam programy sportowe",
        de: "Ich sehe Sportsendungen",
      },
      {
        pl: "Oglądam telewizję od godziny 17 do 18",
        de: "Ich sehe von 5 Uhr bis 6 Uhr fern",
      },
      {
        pl: "To jest film",
        de: "Das ist ein Film",
      },
      {
        pl: "Tak, lubię oglądać telewizję",
        de: "Ja, ich sehe gern fern",
      },
      {
        pl: "Nie, nie lubię oglądać telewizji",
        de: "Nein, ich sehe nicht gern fern",
      },
      {
        pl: "Dostępne są cztery programy",
        de: "Hier gibt es vier programme",
      },
      {
        pl: "programy",
        de: "das Programme",
      },
      {
        pl: "Co pasuje?",
        de: "Was passt?",
      },
      {
        pl: "komedia",
        de: "die Komödie",
      },
      {
        pl: "Czy dziś w telewizji jest koncert?",
        de: "Gibt es heute Abend ein Konzert im Fernsehen?",
      },
      {
        pl: "Kryminały są dla mnie ekscytujące",
        de: "Ich finde Krimi spannend",
      },
      {
        pl: "Codziennie ogląda wiadomości",
        de: "Sie sieht Jeden tag die Nachrichten",
      },
      {
        pl: "film dokumentalny",
        de: "der Dokumentarfilm",
      },
    ],
  },
];

const ZDANIA10 = [
  {
    name: "Niemiecki: Godziny",
    lang: 'de',
    zdania: [
      {
        pl: "Która jest godzina?",
        de: "Wie viel Uhr ist es?",
      },
      {
        pl: "Która jest teraz godzina? (Wie s....) ",
        de: "Wie spät ist es?",
      },
      {
        pl: "Jest za kwandrans czwarta",
        de: "Es ist Viertel von vier",
      },
      {
        pl: "Jest wpół do dziesiątej",
        de: "Es ist halb zehn",
      },
      {
        pl: "Jest pięć po wpół do trzeciej",
        de: "Es ist fünf nach halb drei",
      },
      {
        pl: "Jest za dziesięć dwunasta",
        de: "Es ist zehn vor zwölf",
      },
      {
        pl: "Jest pięć po szóstej.",
        de: "Es ist fünf nach sechs",
      },
      {
        pl: "Tina codziennie wstaje o siódmej",
        de: "Tina steht jeden Tag um sieben Uhr auf",
      },
      {
        pl: "Najpierw idzie do łazienki",
        de: "Sie geht zunächst ins Bad",
      },
      {
        pl: "Następnie idzie do kuchni i je śniadanie",
        de: "Dann geht sie in die küche und frühstück",
      },
      {
        pl: "Jest dwadzieścia po drugiej",
        de: "Es ist zwanzig nach zwei",
      },
      {
        pl: "Jest kwadrans (pietnaście) po drugiej",
        de: "Es ist Viertel nach zwei",
      },
      {
        pl: "Jest za dziesięć trzecia",
        de: "Es ist zehn vor drei",
      },
      {
        pl: "O wpół do ósmej Tina jedzie autobusem do szkoły",
        de: "Um halb acht Uhr fährt Tina mit dem Bus zur Schule",
      },
      {
        pl: "Zajęcia zaczynają się dziesięć po ósmej",
        de: "Die Unterricht fängt um zehn nach acht Uhr an",
      },
      {
        pl: "Szkoła kończy się o 13:20 i Tina wraca do domu",
        de: "Um 13:20 Uhr ist die Schule aus und Tina fährt nach Hause zurück",
      },
      {
        pl: "Szkoła kończy się o 13:20 i Tina wraca do domu",
        de: "Um 13:20 Uhr ist die Schule aus und Tina fährt nach Hause zurück",
      },
      {
        pl: "O 14:30 po obiedzie Tina odrabia pracę domową",
        de: "Um 14:30 Uhr nach dem Mittagessen mach Tina Hausaufgaben",
      },
      {
        pl: "O której godzinie Tina wstaje?",
        de: "Um wie viel Uhr stehft Tina auf?",
      },
      {
        pl: "O której godzinie Tina wychodzi do szkoły?",
        de: "Um wie viel Uhr fährt Tina zur Schule",
      },
      {
        pl: "O której godzinie Tina wychodzi do szkoły?",
        de: "Wie viele Studen bleibt Tina in der Schule?",
      },
      {
        pl: "Co Tina robi po południu?",
        de: "Was macht Tina am Nachmittag?",
      },
      {
        pl: "O 19:00 rodzina Malin je kolację",
        de: "Um 19:00 Uhr isst Familie Malin zu Abend",
      },
      {
        pl: "Ja wstaję o 6:30",
        de: "Ich stehe um 6:30 auf",
      },
      {
        pl: "Codziennie oglądam telewizję",
        de: "Ich sehe jede Tag fern",
      },
      {
        pl: "wstać z łóżka",
        de: "aufstehen",
      },
      {
        pl: "Jest piętnaście po siódmej",
        de: "Es ist fünfzehn nach sieben",
      },
      {
        pl: "Idę do łazienki",
        de: "Ich gehe ins bad",
      },
      {
        pl: "Najpierw",
        de: "Zundichst",
      },
      {
        pl: "dann",
        de: "potem",
      },
      {
        pl: "dann",
        de: "potem",
      },
      {
        pl: "Zajęcia rozpoczynają się o godz. 8.10",
        de: "Der Unterricht fängt um 8:10 Uhr an",
      },
      {
        pl: "dzwonić",
        de: "Ruft",
      },
      {
        pl: "Szkoła kończy się o godzinie 13.20 i Tina wraca do domu",
        de: "Um 13.20 Uhr ist die Schule aus und Tina fahrt nach Hause zurück",
      },
      {
        pl: "dwa razy w tygodniu",
        de: "zwei mal in der woche",
      },
      {
        pl: "isc spac",
        de: "Schlafen gehen",
      },
      {
        pl: "pozostać / zostać",
        de: "bleiben",
      },
    ],
  },
];

const ZDANIA11 = [
  {
    name: "Niemiecki: Karta pracy",
    lang: 'de',
    zdania: [
      {
        pl: "czytać ksiąki",
        de: "lesen Bücher",
      },
      {
        pl: "grać na pianinie",
        de: "spielen Klavier",
      },
      {
        pl: "jechać samochodem",
        de: "fahren mit dem Auto",
      },
      {
        pl: "iść do restauracji",
        de: "gehen zum Restaurant",
      },
      {
        pl: "jechać na rowerze",
        de: "fahren Rad",
      },
      {
        pl: "brać prysznic",
        de: "duschen",
      },
      {
        pl: "jeść",
        de: "essen",
      },
      {
        pl: "odrabiać zadania domowe",
        de: "machen Hausaufgaben",
      },
      {
        pl: "spiewać piosenkę",
        de: "singen ein Lied",
      },
      {
        pl: "uczyć się języka niemieckiego",
        de: "lernen Deutsch",
      },
      {
        pl: "iść do szkoły",
        de: "gehen in die Schule",
      },
      {
        pl: "bawić się / grać z moimi przyjaciółmi",
        de: "spielen mit meinem Freunden",
      },
      {
        pl: "pracować w ogrodzie",
        de: "arbeiten im Garten",
      },
      {
        pl: "robić porządek",
        de: "machen Ordnung",
      },
      {
        pl: "tańczyć",
        de: "tanzen",
      },
      {
        pl: "iść spać",
        de: "gehen schlafen",
      },
      {
        pl: "grać na komputerze",
        de: "spielen Komputer",
      },
      {
        pl: "pić mleko",
        de: "trinen Milch",
      },
      {
        pl: "spać",
        de: "schlafen",
      },
      {
        pl: "odwiedzić babcię i dziadka",
        de: "besuchen Oma und Opa",
      },
      {
        pl: "pisać e-mail",
        de: "schreiben eine e-mail",
      },
      {
        pl: "malować obraz",
        de: "malen ein Bild",
      },
      {
        pl: "iść do domu",
        de: "gehen nach Hause",
      },
      {
        pl: "gotować",
        de: "kochen",
      },
      {
        pl: "dziecko płacze",
        de: "Das Kind weint",
      },
      {
        pl: "Ta kobieta to moja kuzynka",
        de: "Diese Frau ist meine Cousine",
      },
      {
        pl: "Nie znam tego męzczyzny",
        de: "Ich kenne diesen Mann nicht",
      },
      {
        pl: "To jest moja matka",
        de: "Das ist meine Mutter",
      },
      {
        pl: "Ojciec Martina jest Francuzem",
        de: "Martins Vater ist Franzose",
      },
      {
        pl: "Lisa często odwiedza swoich rodziców",
        de: "Lisa besuch oft ihre Eltern",
      },
      {
        pl: "Julia ma swóch synów",
        de: "Julia hat zwie Söhne",
      },
      {
        pl: "Moja córka chodzi do szkoły podstawowe",
        de: "Meine Tochter geht in die Grundschule",
      },
      {
        pl: "Mój brat chodzi do gimnazjum",
        de: "Mein Bruder geht in das Gymnasium",
      },
      {
        pl: "Moja siostra jest pielęgniarką",
        de: "Meine Schwester ist Krankenschwester",
      },
      {
        pl: "Mark ma sześcioro rodzeństwa",
        de: "Mart hat sechs Geschwister",
      },
      {
        pl: "rodzicie",
        de: "die Eltern",
      },
      {
        pl: "rodzina",
        de: "die Familie",
      },
      {
        pl: "córka",
        de: "die Tochter",
      },
      {
        pl: "męzczyzna",
        de: "der Mann",
      },
      {
        pl: "dziecko",
        de: "das Kind",
      },
      {
        pl: "Czy idziesz jutro do szkoły?",
        de: "Gehst du morgen zur Schule?",
      },
      {
        pl: "Ona odrabia we wtorki zadanie domowe",
        de: "Sie macht dienstags ihre Hausaufgaben",
      },
      {
        pl: "Kto pije chętnie mleko i je słodycze?",
        de: "Wer trinkt gerne Milch und isst Süßes?",
      },
      {
        pl: "Czy Pani idzie w środę do restauracji?",
        de: "Gehen Sie am Mittwoch in das Restaurant?",
      },
      {
        pl: "Oni jadą teraz autem",
        de: "Sie fahren jetzt mit dem Auto",
      },
      {
        pl: "Chciałbym w sobotę odwiedzić babcię i dziadka",
        de: "Ich möchte am Samstag Oma und Opa besuchen",
      },
      {
        pl: "Ona chciałaby gotować zupę pomidorową",
        de: "Sie möchte Tomatensuppe kochen",
      },
      {
        pl: "Ona chciałaby gotować zupę pomidorową",
        de: "Sie möchte Tomatensuppe kochen",
      },
      {
        pl: "Nie idziemy jutro do szkoły",
        de: "Wir gehen morgen nicht zur Schule",
      },
      {
        pl: "Ona nie maluje obrazka",
        de: "Sie malt kein Bild",
      },
      {
        pl: "Czy Pani pisze e-mail?",
        de: "Schreiben Sie E-Mail?",
      },
      {
        pl: "Czy Wy chcecie uczyć się codziennie niemieckiego?",
        de: "Wollen Sie jeden Tag Deutsch lernen?",
      },
      {
        pl: "Oni śpią w sobotę od 10 do 10",
        de: "Sie schlafen am Samstag von 10 bis 10 Uhr",
      },
      {
        pl: "Czy Pan chce zagrać z moimi przyjaciółmi?",
        de: "Möchten Sie mit meinen Freunden spielen?",
      },
      {
        pl: "Teraz biorę prysznic i jem śniadanie",
        de: "Jetzt dusche ich und esse Frühstück",
      },
    ],
  },
];

const ZDANIA12 = [
  {
    name: "Niemiecki: mod 3 kap 3",
    lang: 'de',
    zdania: [
      {
        pl: "program telewizyjny",
        de: "das Fernsehprogramm",
      },
      {
        pl: "telewizor",
        de: "der Fernseher",
      },
      {
        pl: "oglądać telewizję",
        de: "fernsehen",
      },
      {
        pl: "teleturniej",
        de: "die Quizshow",
      },
      {
        pl: "wiadomości",
        de: "die Nachrichten",
      },
      {
        pl: "film",
        de: "der Film",
      },
      {
        pl: "serial rysunkowy",
        de: "die Zeichentrickserie",
      },
      {
        pl: "film dokumentalny",
        de: "der Dokumentarfilm",
      },
      {
        pl: "program kulturalny",
        de: "das Kulturprogramm",
      },
      {
        pl: "kryminał",
        de: "der Krimi",
      },
      {
        pl: "program sportowy",
        de: "die Sportsendung",
      },
      {
        pl: "komedia",
        de: "die Komödie",
      },
      {
        pl: "koncert",
        de: "das Konzert",
      },
      {
        pl: "serial",
        de: "die Serie",
      },
      {
        pl: "wesoły",
        de: "lustig",
      },
      {
        pl: "głupi",
        de: "blöd",
      },
      {
        pl: "nudny",
        de: "langweilig",
      },
      {
        pl: "informacyjny",
        de: "informativ",
      },
      {
        pl: "ulubiony program",
        de: "die Lieblingssendung",
      },
      {
        pl: "ulubiony film",
        de: "der Lieblingsfilm",
      },
      {
        pl: "wiadomości telewizyjne",
        de: "die Fernsehnachrichten",
      },
      {
        pl: "wiadomości sportowe",
        de: "die Sportnachrichten",
      },
      {
        pl: "Czy jesteś fanem telewizji?",
        de: "Bist du ein Fernsehfan?",
      },
      {
        pl: "Czy oglądasz chętnie telewizję?",
        de: "Siehst du gern fern?",
      },
      {
        pl: "Ile godzin na dzień oglądasz telewizję?",
        de: "Wie viele Stunden pro Tag siehst du fern?",
      },
      {
        pl: "Od której do której oglądasz telewizję?",
        de: "Von wann bis wann siehst du fern?",
      },
      {
        pl: "Oglądam telewizję",
        de: "Ich sehe fern",
      },
      {
        pl: "Oglądasz telewizję",
        de: "Du siehst fern",
      },
      {
        pl: "Jaka jest twoja ulubiona audycja?",
        de: "Was ist deine Lieblingssendung?",
      },
      {
        pl: "Moją ulubioną audycją jest sport",
        de: "Meine Lieblingssendung ist sport",
      },
      {
        pl: "Co sądzisz o tym filmie?",
        de: "Wie findest du den Film?",
      },
      {
        pl: "Sądzę, że jest ekscytujący",
        de: "Ich finde ihn spannend",
      },
      {
        pl: "Co jest teraz w telewizji?",
        de: "Was gibt es jetzt im Fernsehen?",
      },
      {
        pl: "Która jest godzina?",
        de: "Wie viel Uhr ist es?",
      },
      {
        pl: "Jest godzina 20.00",
        de: "Es ist 20.00 Uhr",
      },
      {
        pl: "Czy oglądasz chętnie telewizję?",
        de: "Siehst du gern fern?",
      },
      {
        pl: "Mój dziadek jest fanem telewizji",
        de: "Mein Opa ist Fernsehfan",
      },
      {
        pl: "Jak ci się podoba ten film?",
        de: "Wie findest du den Film?",
      },
      {
        pl: "Myślę, że jest zabawny",
        de: "Ich finde ihn lustig",
      },
      {
        pl: "dziecko",
        de: "das Kind",
      },
      {
        pl: "Czy idziesz jutro do szkoły?",
        de: "Gehst du morgen zur Schule?",
      },
      {
        pl: "Ona odrabia we wtorki zadanie domowe",
        de: "Sie macht dienstags ihre Hausaufgaben",
      },
      {
        pl: "Kto pije chętnie mleko i je słodycze?",
        de: "Wer trinkt gerne Milch und isst Süßes?",
      },
      {
        pl: "Czy Pani idzie w środę do restauracji?",
        de: "Gehen Sie am Mittwoch in das Restaurant?",
      },
      {
        pl: "Oni jadą teraz autem",
        de: "Sie fahren jetzt mit dem Auto",
      },
      {
        pl: "Chciałbym w sobotę odwiedzić babcię i dziadka",
        de: "Ich möchte am Samstag Oma und Opa besuchen",
      },
      {
        pl: "Ona chciałaby gotować zupę pomidorową",
        de: "Sie möchte Tomatensuppe kochen",
      },
      {
        pl: "Ona chciałaby gotować zupę pomidorową",
        de: "Sie möchte Tomatensuppe kochen",
      },
      {
        pl: "Nie idziemy jutro do szkoły",
        de: "Wir gehen morgen nicht zur Schule",
      },
      {
        pl: "Ona nie maluje obrazka",
        de: "Sie malt kein Bild",
      },
      {
        pl: "Czy Pani pisze e-mail?",
        de: "Schreiben Sie E-Mail?",
      },
      {
        pl: "Czy Wy chcecie uczyć się codziennie niemieckiego?",
        de: "Wollen Sie jeden Tag Deutsch lernen?",
      },
      {
        pl: "Oni śpią w sobotę od 10 do 10",
        de: "Sie schlafen am Samstag von 10 bis 10 Uhr",
      },
      {
        pl: "Czy Pan chce zagrać z moimi przyjaciółmi?",
        de: "Möchten Sie mit meinen Freunden spielen?",
      },
      {
        pl: "Teraz biorę prysznic i jem śniadanie",
        de: "Jetzt dusche ich und esse Frühstück",
      },
    ],
  },
];

const ZDANIA14 = [
  {
    name: "Niemiecki: mod 3 - niedziela",
    lang: 'de',
    zdania: [
      {
        pl: "Rankiem",
        de: "am Morgen",
      },
      {
        pl: "przed południem",
        de: "am Vormittag",
      },
      {
        pl: "po południu",
        de: "am Nachmittag",
      },
      {
        pl: "wieczorem",
        de: "am Abend",
      },
      {
        pl: "do kina",
        de: "ins Kino",
      },
      {
        pl: "do klubu tenisowego",
        de: "in den Tennisclub",
      },
      {
        pl: "do domu",
        de: "nach Hause",
      },
      {
        pl: "do restauracji",
        de: "ins Restaurant",
      },
      {
        pl: "na boisku sportowym",
        de: "auf den Sportplatz",
      },
      {
        pl: "na basen",
        de: "ins Schwimmbad",
      },
      {
        pl: "do parku",
        de: "in den Park",
      },
      {
        pl: "do szkoły językowej",
        de: "in die Sprachschule",
      },
      {
        pl: "do kościoła",
        de: "in die Kirche",
      },
      {
        pl: "Dokąd Tina wybiera się w środę po południu?",
        de: "Wohin geht Tina am Mittwochnachmittag?",
      },
      {
        pl: "W środę po południu Tina chodzi do klubu tenisowego.",
        de: "Am Mittwochnachmittag geht Tina in den Tennisclub",
      },
      {
        pl: "Co robi Tina w Niedzielę?",
        de: "Was macht Tina am Sonntag?",
      },
      {
        pl: "W niedzielę Tina jedzie do Monachium",
        de: "Am Sonntag fährt Tina nach München",
      },
      {
        pl: "Czy Tina w poniedziałek idzie do Brigitte?",
        de: "Geht Tina am Montag zu Brigitte?",
      },
      {
        pl: "Nie, w poniedziałek ona idzie na basen",
        de: "Nein, am Montag geht sie ins Schwimmbad",
      },
      {
        pl: "W poniedziałek po południu idę do kina",
        de: "Ich gehe am Montagnachmittag ins kino",
      },
      {
        pl: "We wtorek rano on chodzi do parku",
        de: "Er geht am Dienstagvormittag in den Park",
      },
      {
        pl: "W piątek wieczorem my idziemy do kina",
        de: "Wir gehen am Freitagabend ins Kino",
      },
      {
        pl: "My idziemy do domu",
        de: "Wir gehen nach Hause",
      },
      {
        pl: "On chce iść biegać",
        de: "Er möchte joggen",
      },
      {
        pl: "Co sądzisz o filmie?",
        de: "Wie findest du den Film?",
      },
      {
        pl: "Co Panie Bauer sądzi Pan o Quizie?",
        de: "Wie finden Sie die Quizshow, Herr Bauer?",
      },
      {
        pl: "Wo jest/znajduje się Tina ",
        de: "Wo bleibt Tina ",
      },
      {
        pl: "Dlaczego",
        de: "Warum",
      },
      {
        pl: "poniewaź",
        de: "denn?",
      },
      {
        pl: "przygotowywać się do sprawdzianu",
        de: "für eine Klassenarbeit lernen",
      },
      {
        pl: "zostać w domu",
        de: "zu hause bleiben",
      },
      {
        pl: "odwiedzać",
        de: "besuchen",
      },
      {
        pl: "wyspać się",
        de: "ausschlafen",
      },
      {
        pl: "robić kurs pływania",
        de: "einer Schwimmkurs machen",
      },
      {
        pl: "Am Donnerstagnachmittag bleibt Tina zu Hause",
        de: "W czwartek po południu Tina zostaje w domu",
      },
      {
        pl: "Ona uczy się do sprawdzianu",
        de: "Sie lernt für die Klassenarbeit",
      },
      {
        pl: "W sobotę rano Tina śpi / wysypia się",
        de: "Am Samstagmorgen schläft Tina aus",
      },
      {
        pl: "Po południu ona idzie do kina z mamą, tatą i Stefanem",
        de: "Am Nachmittag geht sie mit Mama, Papa und Stefan ins Kino",
      },
      {
        pl: "Dokąd idziesz?",
        de: "Wohin gehst du?",
      },
      {
        pl: "Kiedy on idzie do kina? W sobotę wieczorem",
        de: "Wan geht er ins Kino? Am Samstagabend",
      },
      {
        pl: "Czy masz tez szkołę w Sobotę?",
        de: "Hast du auch am Samstag Schule?",
      },
      {
        pl: "W której jesteś klasie?",
        de: "Welcher Klasse bist du?",
      },
      {
        pl: "Uczęszczam do 8 klasy",
        de: "Ich besuche die Klasse 8",
      },
      {
        pl: "O której się kończy lekcja?",
        de: "Und Wann ist der Unterricht aus?",
      },
      {
        pl: "Uczęszczam na kurs/ zajęcia muzyczne",
        de: "Ich besuche einen Musikkurs",
      },
      {
        pl: "O której godzinie wstajesz?",
        de: "Wie viel Uhr stehst du auf?",
      },
      {
        pl: "O której godzinie zaczyna się szkoła?",
        de: "Wie viel Uhr fängt die Schule an?",
      },
    ],
  },
];

const ZDANIA15 = [
  {
    name: "Agielski - kierunki",
    zdania: [
      {
        pl: "Przepraszam, jak dojdę do posterunku Policji?",
        de: "Excuse me, how do i get to Police station?",
      },
      {
        pl: "Przepraszam, czy w pobliżu znajduje się park miejski?",
        de: "Excuse me, is there a City Park near here?",
      },
      {
        pl: "Przepraszam, gdzie jest Koledż?",
        de: "Excuse me, where is the State College?",
      },
      {
        pl: "Przepraszam, czy możesz mi wskazać drogę do Biblioteki Miejskiej?",
        de: "Excuse,me can you tell me the way to City Library?",
      },
      {
        pl: "iść prosto",
        de: "go straight on",
      },
      {
        pl: "skręcić w prawo",
        de: "turn right",
      },
      {
        pl: "skręcić w lewo",
        de: "turn left",
      },
      {
        pl: "skręć w trzecią po lewej stronie",
        de: "take the third on the left",
      },
      {
        pl: "skręć w drugą po prawej stronie",
        de: "take the second on the right",
      },
      {
        pl: "sygnalizacja świetlna",
        de: "traffic lights",
      },
      {
        pl: "przejście dla pieszych",
        de: "zebra crossing",
      },
      {
        pl: "chodnik",
        de: "sidewalk",
      },
      {
        pl: "rondo",
        de: "roundabout",
      },
      {
        pl: "opposite",
        de: "naprzeciwko",
      },
      {
        pl: "Przejdź obok sygnalizacji świetlnej",
        de: "Go past the traffic lights",
      },
      {
        pl: "Na rondzie skręć w lewo",
        de: "At the roundabout turn left",
      },
      {
        pl: "fabryka",
        de: "factory",
      },
      {
        pl: "kino",
        de: "cinema",
      },
      {
        pl: "szpital",
        de: "hospital",
      },
      {
        pl: "Stadion znajduje się naprzeciwko basenu",
        de: "The stadium is opposite the swimming pool",
      },
      {
        pl: "Kino znajduje się pomiędzy sklepem obuwniczym a kwiaciarnią",
        de: "The cinema is between the shoe shop and the florist",
      },
      {
        pl: "Biuro turystyczne znajduje się obok szpitala",
        de: "The tourist office is next to the hospital",
      },
      {
        pl: "Szkoła jest na ulicy Elton",
        de: "The school is on Elton Street",
      },
      {
        pl: "Kwiaciarnia znajduje się obok piekarni",
        de: "The florist is next to the bakery",
      },
      {
        pl: "Gdzie jest basen?",
        de: "Where is the swimming-pool?",
      },
      {
        pl: "Rynek Główny",
        de: "Market square",
      },
      {
        pl: "Poczta",
        de: "Post Office",
      },
      {
        pl: "Straz pozarna",
        de: "Fire Station",
      },
      {
        pl: "Przystanek autobusowy",
        de: "Bus Station",
      },
      {
        pl: "Szkoła podstawowa",
        de: "Elementary school",
      },
      {
        pl: "Szkoła podstawowa znajduje się za budynkiem Banku",
        de: "The elementary school is in the behind the Bank",
      },
      {
        pl: "kawiarnia",
        de: "Coffee shop",
      },
      {
        pl: "Dziękuję bardzo",
        de: "Thank You very much",
      },
      {
        pl: "Przejdź przez most",
        de: "Go across the bridge",
      },
      {
        pl: "Apteka znajduje się między dworcem kolejowym a szpitalem",
        de: "The pharmacy is between the trains station and the hospital",
      },
      {
        pl: "Stacja benzynowa znajduje się po przeciwległej stronie kawiarni",
        de: "The gas station is across from coffee shop",
      },
    ],
  },
];

export {
  ZDANIA4,
  ZDANIA5,
  ZDANIA6,
  ZDANIA7,
  ZDANIA8,
  ZDANIA10,
  ZDANIA11,
  ZDANIA12,
  ZDANIA14,
  ZDANIA15,
};
